import React from "react";
import { Box } from "@mui/material";
import dayjs from "dayjs";

/** "2026-09" → "Sep 2026". */
export const formatCutoff = (period) => (period ? dayjs(`${period}-01`).format("MMM YYYY") : "");

/**
 * The cutoff a note or document was added from. A client's notes and documents are one list
 * shared by every cutoff, so this is what tells which month each belongs to. Renders nothing
 * for ones saved before cutoffs were recorded.
 */
export default function CutoffTag({ period }) {
	if (!period) return null;

	return (
		<Box
			component="span"
			title={`Added while viewing the ${dayjs(`${period}-01`).format("MMMM YYYY")} cutoff`}
			sx={{
				display: "inline-block",
				ml: 0.75,
				px: 0.75,
				borderRadius: 99,
				backgroundColor: "#EBF5FF",
				color: "#1A3F7A",
				fontSize: 10,
				fontWeight: 700,
				lineHeight: "16px",
				whiteSpace: "nowrap",
				verticalAlign: "middle",
			}}
		>
			{formatCutoff(period)} cutoff
		</Box>
	);
}
